import styled from '@emotion/styled';
import { ListItemSecondaryText } from '$components/List/List';
import COLORS from '$variables/colors';
import { spacing, breakpoints } from '$variables/theme';

export const ListItemErrorText = styled(ListItemSecondaryText)`
  color: ${COLORS.red};
  margin-top: ${spacing.xSmall};
`;

export const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px ${spacing.medium};
  border-bottom: 1px solid ${COLORS.grey};
`;

export const KeepOnOneLine = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ColumnsOnMobile = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: ${breakpoints.small}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const RightGradeDecorations = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StudentNameContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const PillContainer = styled.div`
  margin-left: ${spacing.xSmall};
`;
